const mainContainer = {
    height: "50em",
    width: "90%",
    backgroundColor: "white",
    borderRadius: "10px",
    padding: "1.5rem 2.5rem",
  },
  headerContainer = {
    display: "flex",
    justifyContent: "space-between",
  },
  titleContainer = {
    display: "flex",
    gap: "1rem",
  },
  titleStyles = {
    fontSize: "1.4375rem",
    fontStyle: "normal",
    fontWeight: 700,
    lineHeight: "150%",
    color: "black",
  },
  comparisonsContainer = {
    height: "100%",
    overflow: "scroll",
  },
  comparisonContainer = {
    margin: "1.5rem 0rem",
  },
  comparisonTitle = {
    fontSize: "1.4375rem",
    fontStyle: "normal",
    fontWeight: 500,
    lineHeight: "150%",
  };

export {
  mainContainer,
  headerContainer,
  titleContainer,
  titleStyles,
  comparisonsContainer,
  comparisonContainer,
  comparisonTitle,
};
